// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background: #0a0a0a;
  color: #fff !important;
  height: 31rem;
  padding: 110px 0px;
}
.footer .ant-collapse .ant-collapse-content {
  border: none !important;
  background-color: #333333 !important;
}
.footer .ant-collapse {
  border: none !important;
}
.home-page-hover {
  font-family: Roboto;
  cursor: pointer !important;
}
.footer .ant-collapse .ant-collapse-item:last-child {
  border: none !important;
  width: auto !important;
}
.footer .ant-col-6 {
  max-width: 100% !important;
}
.footer-section {
  padding: 10px 20px;
}

.footer-title {
  color: #b3b5b4 !important;
  font-size: 19px;
  font-style: Roboto condensed Regular;
  font-weight: 400;
  line-height: 34.5px;
}

.footer-links {
  color: #fff !important;
}

.footer-links .ant-typography {
  color: #fff !important;
  cursor: pointer !important;
  transition: color 0.3s;
}

.footer-links .ant-typography:hover {
  color: #fff !important;
}

.footer-icons .anticon {
  font-size: 20px;
  color: #fff;
  cursor: pointer;
  transition: color 0.3s;
  margin-bottom: 10px !important;
}

.footer-icons .anticon:hover {
  color: #cccccc;
}

.footer-contact {
  /* margin-top: 10px; */
  color: #fff !important;
}
.footer-contact-text.ant-typography {
  font-family: Roboto;
  color: #fff !important;
  text-decoration: underline !important;
}

.footer-bottom {
  margin-bottom: 1px;
  border-top: 1px solid #d2042d;
  padding: 20px 0px;
  text-align: center;
  background-color: #d2042d;
  font-size: 14px;
  margin-top: 7rem;
}

.footer-col {
  padding-top: 15px;
  padding-left: 7px;
  padding-bottom: 15px;
}

.footer-hr {
  margin-left: 17px;
  margin-right: 17px;
}

.footer-collapse-container {
  width: 100%;
  padding-right: 20px;
}

.footer-space-between {
  padding-top: 15;
  padding-left: 15;
}

.footer-links-text {
  font-family: Roboto;
  cursor: pointer;
  display: inline-block;
}

@media (max-width: 768px) {
  .footer {
    background-color: #333333;
    color: #fff !important;
    height: auto;
    padding: 25px 0px 0px 0px !important;
  }
  .footer-bottom {
    border-top: 1px solid #d2042d;
    padding: 20px 0px;
    text-align: center;
    background-color: #d2042d;
    font-size: 14px;
    display: flex;
    align-items: end;
  }
}
.footer-links {
  display: flex;
  flex-direction: column;
  gap: 20px; /* Same as size={20} in Space */
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,oCAAoC;AACtC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE;IACE,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;IACZ,oCAAoC;EACtC;EACA;IACE,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,+BAA+B;AAC5C","sourcesContent":[".footer {\n  background: #0a0a0a;\n  color: #fff !important;\n  height: 31rem;\n  padding: 110px 0px;\n}\n.footer .ant-collapse .ant-collapse-content {\n  border: none !important;\n  background-color: #333333 !important;\n}\n.footer .ant-collapse {\n  border: none !important;\n}\n.home-page-hover {\n  font-family: Roboto;\n  cursor: pointer !important;\n}\n.footer .ant-collapse .ant-collapse-item:last-child {\n  border: none !important;\n  width: auto !important;\n}\n.footer .ant-col-6 {\n  max-width: 100% !important;\n}\n.footer-section {\n  padding: 10px 20px;\n}\n\n.footer-title {\n  color: #b3b5b4 !important;\n  font-size: 19px;\n  font-style: Roboto condensed Regular;\n  font-weight: 400;\n  line-height: 34.5px;\n}\n\n.footer-links {\n  color: #fff !important;\n}\n\n.footer-links .ant-typography {\n  color: #fff !important;\n  cursor: pointer !important;\n  transition: color 0.3s;\n}\n\n.footer-links .ant-typography:hover {\n  color: #fff !important;\n}\n\n.footer-icons .anticon {\n  font-size: 20px;\n  color: #fff;\n  cursor: pointer;\n  transition: color 0.3s;\n  margin-bottom: 10px !important;\n}\n\n.footer-icons .anticon:hover {\n  color: #cccccc;\n}\n\n.footer-contact {\n  /* margin-top: 10px; */\n  color: #fff !important;\n}\n.footer-contact-text.ant-typography {\n  font-family: Roboto;\n  color: #fff !important;\n  text-decoration: underline !important;\n}\n\n.footer-bottom {\n  margin-bottom: 1px;\n  border-top: 1px solid #d2042d;\n  padding: 20px 0px;\n  text-align: center;\n  background-color: #d2042d;\n  font-size: 14px;\n  margin-top: 7rem;\n}\n\n.footer-col {\n  padding-top: 15px;\n  padding-left: 7px;\n  padding-bottom: 15px;\n}\n\n.footer-hr {\n  margin-left: 17px;\n  margin-right: 17px;\n}\n\n.footer-collapse-container {\n  width: 100%;\n  padding-right: 20px;\n}\n\n.footer-space-between {\n  padding-top: 15;\n  padding-left: 15;\n}\n\n.footer-links-text {\n  font-family: Roboto;\n  cursor: pointer;\n  display: inline-block;\n}\n\n@media (max-width: 768px) {\n  .footer {\n    background-color: #333333;\n    color: #fff !important;\n    height: auto;\n    padding: 25px 0px 0px 0px !important;\n  }\n  .footer-bottom {\n    border-top: 1px solid #d2042d;\n    padding: 20px 0px;\n    text-align: center;\n    background-color: #d2042d;\n    font-size: 14px;\n    display: flex;\n    align-items: end;\n  }\n}\n.footer-links {\n  display: flex;\n  flex-direction: column;\n  gap: 20px; /* Same as size={20} in Space */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
